/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceMetricHierarchyResponse {
    getFixupPrototypeFunction() { return ResourceMetricHierarchyResponse.fixupPrototype; }

    static newInstance(model: Partial<ResourceMetricHierarchyResponse>): ResourceMetricHierarchyResponse {
        let obj = Object.assign(new ResourceMetricHierarchyResponse(), model);
        ResourceMetricHierarchyResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceMetricHierarchyResponse>): ResourceMetricHierarchyResponse {
        if (!model) return null;
        return ResourceMetricHierarchyResponse.newInstance(<ResourceMetricHierarchyResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceMetricHierarchyResponse) {
        if (!obj) return;

        models.ResourceMetricHierarchyResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceMetricHierarchyResponse): boolean {
        Object.setPrototypeOf(obj, ResourceMetricHierarchyResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Message of Resource Metric Hierarchy
     */
    message: string;

    /**
     * Resource Metric Hierarchy Listing
     */
    data: any;

}
